<template>
  <vuex-table :fields="fields" :show_header="false" :table_store="store">
    <template slot="state" slot-scope="{ item }">
      <data-base-status :value="item.state" />
    </template>

    <template slot="selected" slot-scope="{ item }">
      <list-state :recipients_count="item.recipients_count" :value="item.selected" @click="change_selected(item, $event)" />
    </template>
  </vuex-table>
</template>

<script>
  import ListState from '@shared/components/input/input-state-toggle';
  import DataBaseStatus from '@db/components/db/db-state-badge';

  export default {
    components: {
      DataBaseStatus,
      ListState
    },

    props: {
      store: {
        type: String,
        default: ''
      }
    },

    data: () => ({
      edit_id: null
    }),

    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.name'),
            sortable: true,
            class: 'w-25'
          },

          {
            key: 'state',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'recipients_count',
            label: this.$t('db.database.field.recipients'),
            sortable: false,
            class: 'w-25'
          },
          {
            key: 'selected',
            label: '',
            sortable: false,
            class: 'text-center w-25'
          }
        ];
      }
    },

    methods: {
      change_selected: function (item, state) {
        if (state) {
          this.$store.dispatch(`${this.store}/addDataBase`, item);
        } else {
          this.$store.dispatch(`${this.store}/removeDataBase`, item);
        }
      }
    }
  };
</script>

<style lang="scss">
  .worksheet-table-status {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;

    .z-switch {
      margin-right: 20px;
    }
  }
</style>
